import { Pipe, PipeTransform } from '@angular/core';
import {
    DateFormatService,
    browserTimezone
} from '@flyfreely-portal-ui/flyfreely';
import {
    CurrentOrganisation,
    WorkspaceStateService
} from '@flyfreely-portal-ui/workspace';
import moment from 'moment';

@Pipe({ name: 'formatDate', pure: false })
export class FormatDatePipe implements PipeTransform {
    constructor(
        private dateFormatService: DateFormatService,
        private workspaceStateService: WorkspaceStateService
    ) {}

    transform(dateStr: string | Date, timeZone?: string): string | null {
        if (!dateStr) {
            return null;
        }
        // Use the time zone passed in. Falling back on the organisation, then the browser time zones.
        // As a final fallback have moment guess, though this will usually also return the browser or system time.
        const timeZoneToUse =
            timeZone != null
                ? timeZone
                : this.workspaceStateService.getCurrentOrganisation().type ===
                  'organisation_loaded'
                ? (<CurrentOrganisation>(
                      this.workspaceStateService.getCurrentOrganisation()
                  )).organisation.timeZone
                : browserTimezone ?? moment.tz.guess();

        const format = this.dateFormatService.getDateFormat();

        return moment(dateStr).tz(timeZoneToUse).format(format);
    }
}
